
import urlUtils from 'url'

export function scMonitor (reportMonitorParams) {


 try {
  if(window?.xy_App?.$track?.track) {
    
    const { url, errcode, level, errstr, startTime, msg, message, basic, code, ret } = reportMonitorParams
    
    const fe_request_monitor_errcode = Number(errcode || code || (basic && basic.code) || ret || 0)
    const fe_request_monitor_errstr = errstr || msg || message || basic?.msg || '网络不给力啊~~'

    const urlObj = urlUtils.parse(url)
    const basedata = {
      // 基础监控
      fe_request_monitor_id: urlObj.pathname,
      fe_request_monitor_level: level || 0,
      fe_request_monitor_errcode,
      fe_request_monitor_errstr,
      fe_request_monitor_cost_time: +new Date() - startTime
    }

    window?.xy_App?.$track?.trackS('fe_request_monitor_baoguang', basedata)
  }
 } catch(err) {
  console.log('scMonitor', err)
 }

}
